import service from "./service";

const userList = async (search, page, limit) => {
  return service
    .get(`/admin/users?search=${search}&page=${page}&limit=${limit}`)
    .then((response) => {
      return response;
    });
};

const blockedUser = async (id) => {
  return service.patchApi(`admin/users/${id}/block`).then((response) => {
    return response;
  });
};

export default {
  userList,
  blockedUser
};
